const BASE = "https://customer-assets-0z36b82j.emergentagent.net/job_3746c8ad-73a3-4cbb-87f3-7b3af248f392/artifacts";

const SLIDES = [
  { id: "u6j9sp5s", caption: "Purpose-driven entrepreneurial logistics" },
  { id: "ubzt12xc", caption: "Global presence — +190 offices across all continents" },
  { id: "wxmbjpqf", caption: "SGL Australia — our local presence" },
  { id: "97k3q6p4", caption: "Your success is our priority" },
  { id: "tjshr9nf", caption: "Why SGL — benefit from close collaboration & responsive service" },
];

export default function AboutSGL() {
  return (
    <div data-testid="about-sgl">
      <div className="border border-border bg-white p-8 mb-8">
        <div className="font-mono-plex text-[10px] tracking-[0.3em] uppercase text-[#0072B8] mb-3">About Scan Global Logistics</div>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight mb-3">We exist to make the world a little less complicated</h2>
        <p className="text-sm text-muted-foreground max-w-3xl">An overview of Scan Global Logistics — our global scale, local Australian presence, and the service commitment behind the PACT Group partnership.</p>
      </div>

      <div className="space-y-6">
        {SLIDES.map((s, i) => (
          <figure key={s.id} className="border border-border bg-white overflow-hidden" data-testid={`about-slide-${i}`}>
            <img
              src={`${BASE}/${s.id}_image.webp`}
              alt={s.caption}
              loading="lazy"
              className="w-full h-auto block"
            />
            <figcaption className="border-t border-border px-5 py-3 font-mono-plex text-[10px] tracking-widest uppercase text-muted-foreground">
              {String(i + 1).padStart(2, "0")} · {s.caption}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
